<button tiime-button color="primary" strocked (click)="emitReset()" [disabled]="disabled">
  <mat-icon svgIcon="icon-circle-arrow-left"></mat-icon>
  {{ resetText }}
</button>
